export default "__VITE_PUBLIC_ASSET__c86ac490__"